

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { partnersPayoutStatuses } from '../statuses';

export default class PartnersPayoutsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'partners-payouts';
        this.Server = this.props.context.getState().server.partnersPayouts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'idempotencyKey'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'currencyId',
                label: 'currency',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'currencies',
                object: 'currency',
                show: 'name'
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(partnersPayoutStatuses)
            },
            {
                id: 'failureCode',
                label: 'failureCode',
                alignRight: false,
                cell: 'Text',
                displayGrid: false,
                displayDialogDetails: true
            },
            {
                id: 'failureMessage',
                label: 'failureMessage',
                alignRight: false,
                cell: 'Text',
                displayGrid: false,
                displayDialogDetails: true
            },
            {
                id: 'idempotencyKey',
                label: 'idempotencyKey',
                alignRight: false,
                cell: 'Text',
                displayGrid: false,
                displayDialogDetails: true
            },
            {
                id: 'destinationAccountId',
                label: 'destinationAccount',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletAccounts',
                object: 'destinationAccount',
                show: 'accountNumber'
            },
            {
                id: 'walletTransferId',
                label: 'walletTransfer',
                alignRight: false,
                cell: 'Select',
                displayGrid: false,
                displayDialogDetails: true,
                from: 'walletTransfers',
                object: 'walletTransfer',
                show: 'uuid'
            },
            {
                id: 'dateCompleted',
                label: 'dateCompleted',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}